// @flow
/** @jsx h */
/* eslint-disable jsx-a11y/media-has-caption */
import { h, Component } from 'preact'

import styles from './VideoLoop.css'

type Props = {
  byline: string
}

export class Byline extends Component<Props> {
  render () {
    const { byline } = this.props
    return <div className={`skin-border ${styles['byline']}`}>{byline}</div>
  }
}



// WEBPACK FOOTER //
// ./src/v2/article/components/Byline.js